import React, {useState, useEffect, useContext} from 'react'
import Select from 'react-select'
import PropTypes from 'prop-types'
import {
    formatDropDownDataSource,
    formatSelectedOption,
    customFilterOption,
} from '../../utils/utils'
import {apiRequest} from '../../utils/apiHelper'
import {API_URL_RESOURCE} from '../../utils/constants'
import {FormControl, Grid, FormHelperText, InputLabel, Tooltip} from '@material-ui/core'
import {withStyles, makeStyles} from '@material-ui/core/styles'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {MyAccountContext} from '../../myAccount/containers/Layout'
import MarkdownRender from '../../components/MarkdownRender'
import _ from 'lodash'
import MarkDownRenderer from '../../components/MarkdownRender'

const MyAccountReactSelect = props => {
    const HtmlTooltip = withStyles(theme => ({
        tooltip: {
            maxWidth: props.icon.maxwidth || 500,
            fontWeight: 'normal'
        },
    }))(Tooltip)

    const {clientObject, setClientObject} = useContext(MyAccountContext)
    const [optionList, setOptionList] = useState([])
    const [loading, setloading] = useState(props.fetchData ? true : false)
    const [dependentKeyval, setDependentKeyval] = useState({})
    var currentValue = props.endPoint
        ? props.endPoint === 'myaccountprogramentity' && props.fieldValue
            ? {
                  value: props.fieldValue.value,
                  label: props.fieldValue.label,
              }
            : formatSelectedOption(props.fieldValue, props.endPoint)
        : props.fieldValue

    useEffect(() => {
        bindSelectData()
    }, [])

    useEffect(() => {
        setOptionList(props.data, () => {})
    }, [props.data])

    useEffect(() => {
        if (!_.isEqual(dependentKeyval, props.dependentKeyval)) {
            bindSelectData()
            setDependentKeyval(props.dependentKeyval)
        }
    }, [props.dependentKeyval])

    const bindSelectData = () => {
        let headers = {}
        let callApi = true
        if (props.isHeaderpassed) {
            if (props.dependentKey) {
                props.dependentKeyval && Object.keys(props.dependentKeyval).length > 0
                    ? (headers = {
                          ...{'client-entity-id': clientObject.cliententityid},
                          ...props.dependentKeyval,
                      })
                    : (callApi = false)

                for (const key in headers) {
                    if (!headers.hasOwnProperty(key)) {
                        callApi = false
                        return
                    }
                }
            } else {
                headers = {'client-entity-id': clientObject.cliententityid}
            }
        }

        if (callApi) {
            if (props.fetchData) {
                const callApi = async () => {
                    setloading(true)
                    const response = await apiRequest(
                        `${API_URL_RESOURCE.URL}${props.endPoint}`,
                        props.param,
                        headers
                    )
                    setOptionList(
                        response.success
                            ? formatDropDownDataSource(response.success, props.endPoint)
                            : []
                    )
                    if (response.success && props.getOptionsData)
                        props.actionMethods(
                            props.fieldName,
                            formatDropDownDataSource(response.success, props.endPoint)
                        )
                    setloading(false)
                }
                callApi()
            } else if (props.data) {
                setOptionList(props.data)
                if (props.getOptionsData && props.data && props.data.length)
                    props.actionMethods(props.fieldName, props.data)
            }
        } else {
            setOptionList([])
            currentValue = 0
            setloading(false)
            if (props.getOptionsData) props.actionMethods(props.fieldName, [])
        }
    }

    const handleChange = option => {
        if (props.multiSelect) {
            let selectedOptions = []
            if (option)
                selectedOptions = option.map(p => (p.obj === undefined ? p : p.obj))
            props.onChange(selectedOptions)
        } else props.onChange(option ? option.obj : {})
    }

    if (!props.toShow) {
        return null
    }

    if (props.isHide) {
        return null
    }

    const selectedOptVal = props.multiSelect
        ? currentValue
        : currentValue
        ? currentValue.hasOwnProperty('value')
            ? currentValue.value !== undefined &&
              currentValue.value !== null &&
              currentValue.value !== ''
                ? currentValue
                : 0
            : 0
        : 0

    return (
        <Grid
            item
            xs={12}
            md
            className={`react-select-grid input-field__main_container ${props.cssClass}`}
        >
            <FormControl
                fullWidth
                error={props.errorText ? true : false}
                className="input-field__container"
            >
                <InputLabel
                    required={props.required}
                    data-shrink={true}
                    className="react-select-label"
                >
                    <span className="react-select-label__text">{props.fieldName}</span>
                    <span>
                        {props.icon && (
                            <HtmlTooltip
                                title={
                                    props.icon.toolTip ? (
                                        <MarkdownRender value={props.icon.toolTip} />
                                    ) : (
                                        ''
                                    )
                                }
                                placement={props.icon.toolTipPlacement}
                                arrow={props.icon.isArrow}
                            >
                                <span className="info_icon">
                                    {'  '}
                                    <FontAwesomeIcon
                                        icon={['fal', props.icon.iconType]}
                                    ></FontAwesomeIcon>
                                </span>
                            </HtmlTooltip>
                        )}
                    </span>
                </InputLabel>

                <Select
                    className="basic-single"
                    classNamePrefix="select"
                    // defaultValue={props.defaultValue}
                    value={selectedOptVal}
                    isDisabled={props.isDisabled || props.isDisable}
                    isLoading={loading || props.isLoading}
                    isClearable={props.isClearable}
                    isSearchable={props.isSearchable}
                    name={props.name}
                    isMulti={props.multiSelect}
                    options={optionList}
                    onChange={handleChange}
                    placeholder={props.placeholder}
                    filterOption={customFilterOption}
                    theme={theme => ({
                        ...theme,
                        borderRadius: 0,
                    })}
                    closeMenuOnSelect={props.multiSelect ? false : true}
                />
                <FormHelperText>{props.errorText}</FormHelperText>
            </FormControl>
        </Grid>
    )
}

MyAccountReactSelect.propTypes = {
    isDisabled: PropTypes.bool,
    isLoading: PropTypes.bool,
    isClearable: PropTypes.bool,
    isSearchable: PropTypes.bool,
    data: PropTypes.array,
    placeholder: PropTypes.string,
    multiSelect: PropTypes.bool,
    toShow: PropTypes.bool,
}

MyAccountReactSelect.defaultProps = {
    isDisabled: false,
    isLoading: false,
    isClearable: true,
    isSearchable: true,
    data: [],
    placeholder: '',
    multiSelect: false,
    toShow: true,
}

export default MyAccountReactSelect
